import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferSlugSuggestionMutation = createMutationHook(
  OffersApiClient.getSlugSuggestion,
  {
    mutationKey: ['getSlugSuggestion'],
  },
)
